export default function reducer(state, action) {
  switch (action.type) {
    // notification
    case 'show-error-notification':
      return {
        ...state,
        notification: {  
          notificationText: action.payload,
          open: true,
          severity: "error"
        }
      };
    case 'show-success-notification': 
      return {
        ...state, 
        notification: {
          notificationText: action.payload,
          open: true,
          severity: "success"
        }
      }
    case 'stop-notification':
      return {
        ...state,
        notification: {
          notificationText: "",
          open: false,
        }
      }

    // loader 
    case 'show-loader': {
      return {
        ...state,
        loader: {
          visible: true,
        }
      }
    }
    case 'hide-loader': {
      return {
        ...state,
        loader: {
          visible: false,
        }
      }
    }
    default:
      throw new Error();
  }
}